export const actions = {
  RESET: 'ROOT::RESET',
  SET: 'ROOT::SET',
};

export function resetState() {
  return {type: actions.RESET};
}

export function setState(state) {
  return {
    type: actions.SET,
    payload: {
      state,
    },
  };
}
